import { lazy } from 'react';

export const ToolbarDecimalSeparatorForNumberDetectionMenu = lazy(
  () => import('./ToolbarDecimalSeparatorForNumberDetectionMenu'),
);
export const ToolbarDetectedNumbers = lazy(() => import('./ToolbarDetectedNumbers'));
export const ToolbarInstructions = lazy(() => import('./ToolbarInstructions'));
export const ToolbarFormats = lazy(() => import('./ToolbarFormats'));
export const ToolbarTagNameMenu = lazy(() => import('./ToolbarTagNameMenu'));
export const ToolbarTextAlignMenu = lazy(() => import('./ToolbarTextAlignMenu'));
